var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiQmsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_434_876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 10.6667V8.00004C5.3335 7.2928 5.61445 6.61452 6.11454 6.11442C6.61464 5.61433 7.29292 5.33337 8.00016 5.33337H10.6668",
    stroke: "#0B51C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 21.3334V24C5.3335 24.7073 5.61445 25.3856 6.11454 25.8857C6.61464 26.3858 7.29292 26.6667 8.00016 26.6667H10.6668",
    stroke: "#0B51C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3335 5.33337H24.0002C24.7074 5.33337 25.3857 5.61433 25.8858 6.11442C26.3859 6.61452 26.6668 7.2928 26.6668 8.00004V10.6667",
    stroke: "#0B51C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3335 26.6667H24.0002C24.7074 26.6667 25.3857 26.3858 25.8858 25.8857C26.3859 25.3856 26.6668 24.7073 26.6668 24V21.3334",
    stroke: "#0B51C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 16H21.3332",
    stroke: "#0B51C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 12H18.6665",
    stroke: "#0B51C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 20H15.9998",
    stroke: "#0B51C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_434_876"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiQmsIcon);
export default __webpack_public_path__ + "static/media/ai_qms_icon.012cc6038588b994807ae04e24445afb.svg";
export { ForwardRef as ReactComponent };